import { Icon } from "@mdi/react";

import { mdiCheck, mdiContentSavePlus } from "@mdi/js";
import {
  selectHasWellDataError,
  selectIsTypeWellSavable,
  useForecastStore
} from "stores/forecast";

import { TypeWellAction } from "./TypeWellAction";

interface SaveAsToggleProps {
  setCloneTypeWellOpen: (isOpen: boolean) => void;
  setIsPopoverOpen: (isOpen: boolean) => void;
}

export function SaveAsToggle(props: SaveAsToggleProps) {
  const { setCloneTypeWellOpen, setIsPopoverOpen } = props;

  const hasWellDataError = useForecastStore(selectHasWellDataError);
  const isTypeWellSavable = useForecastStore(selectIsTypeWellSavable);

  return (
    <TypeWellAction
      onClick={() => {
        setCloneTypeWellOpen(true);
        setIsPopoverOpen(false);
      }}
      disabled={hasWellDataError}>
      {isTypeWellSavable ? (
        <Icon path={mdiContentSavePlus} size={"18px"} />
      ) : (
        <Icon path={mdiCheck} size={"18px"} />
      )}
      Save As
    </TypeWellAction>
  );
}
